module.exports = __webpack_public_path__ + "static/media/online-registration-banner2.2ae92d18.png";